import React, { FunctionComponent, useContext } from 'react'
import { Typography } from '@mui/material'
import court from '../../assets/images/court.svg'
import { HeaderLayoutBox } from '../box'
export const I3Header: FunctionComponent = () => {
  return (
    <HeaderLayoutBox>
      <img style={{ width: '4rem', height: '3rem' }} src={court} alt='Court icon' />
      <Typography
        component='h1'
        aria-label='Govrec paydirect'
        sx={{ typography: { md: 'h5', sm: 'h6', xs: 'h6' }, p: '0.4rem' }}
      >
        Govrec.com/paydirect
      </Typography>
    </HeaderLayoutBox>
  )
}

// sx={{ typography: { md: 'body2', sm: 'body2small', xs: 'body2small' } }}

{
  /* <Typography sx={{ p: '0.4rem' }} variant='h5'>*/
}
